import React from "react";
import TextAreaAutosize from 'react-textarea-autosize';
import { WithTranslation, withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";

import { IOperationData, TranslationKeyType, ICardToListOperation, ISelectCardOption, ICardToListOptionType } from "../../../constants/types";

import './CardToListOperation.scss'
import Icon from "../../icon/Icon";

interface Props extends WithTranslation {
    operation: ICardToListOperation,
    data: IOperationData,
    onChange: (changes: IOperationData) => void
};

interface State {
    showInfoText: boolean;
};

//minimum length in order to "OK" operation
const minInputLength = 3;

class CardToListOperation extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            showInfoText: false,
        }
    }

    componentDidMount() {
        const { data, onChange } = this.props;
        this.setState({ showInfoText: "companyNomorAgreementNo" == data?.value })
    }


    onSelectSuggestion = (value: string) => {
        const { data, onChange } = this.props;
        onChange({
            ...data,
            value: value,
            OK: value.length >= minInputLength
        });
        this.setState({ showInfoText: "companyNomorAgreementNo" == value })
    }

    renderTextInformation() {
        const { t, data } = this.props;
        return <div
            className="card-to-list-suggestion fade-in"
            style={{
                marginTop: "1rem",
                backgroundColor: "whitesmoke",
                padding: "0.5rem",
                borderRadius: "0.25rem",
                cursor: "default"
            }}>
            På <a href="https://www.skadedjursshop.se/" target="_blank">skadedjursshop</a> erbjuder vi mängder av varor för skadedjursbekämpning om ni vill handla på egen hand. Det går givetvis även bra att fortsätta med denna anmälan.
        </div >
    }


    renderSuggestions(suggestions: ICardToListOptionType[]) {
        const { t, data } = this.props;

        return <Row className="card-to-list-suggestions">
            {suggestions.map(suggestion => {
                const suggestionString = t(suggestion.text as unknown as TemplateStringsArray);

                return <Col xs={12} className="card-to-list-suggestion fade-in" aria-selected={suggestion.key === data?.value} onClick={() => this.onSelectSuggestion(suggestion.key)}>
                    <div className="card-to-list-suggestion-checkmarker">
                        <Icon type={"CHECKMARK"} iconProps={{ size: '1.5rem' }} />
                    </div>
                    {suggestionString}
                </Col>;
            })}
            {this.state.showInfoText && this.renderTextInformation()}

        </Row>
    }

    onCardSelect(id: string) {
        this.props.onChange({
            OK: false,
            discarded: false,
            type: id,
            value: undefined
        });
        this.setState({ showInfoText: false })
    }

    renderOptions(options: { option: ISelectCardOption, description: TranslationKeyType, suggestions: ICardToListOptionType[] }[]) {
        const { t, data } = this.props;

        return <>
            <Row className="card-to-list-cards">
                {options.map(({ option }) => {
                    return <Col xs={6} md={3} className="fade-in">
                        <div className="card-to-list-card" aria-selected={option.id === data?.type} onClick={() => this.onCardSelect(option.id)}>
                            <div className="card-to-list-card-checkmarker">
                                <Icon type={"CHECKMARK"} iconProps={{ size: '1.5rem' }} />
                            </div>
                            <div className="card-to-list-card-icon">
                                <Icon type={option.icon} iconProps={{ size: '3.5rem' }} />
                            </div>
                            <div className="card-to-list-card-title">
                                {this.props.t(option.name as unknown as TemplateStringsArray)}
                            </div>
                        </div>
                    </Col>;
                })}
            </Row>
            {options.map(({ option, description, suggestions }) => {
                if (option.id === data?.type) {
                    return <>
                        <p className="card-to-list-description fade-in">{t(description as unknown as TemplateStringsArray)}</p>
                        {this.renderSuggestions(suggestions)}
                    </>
                }
            })}
        </>;
    }


    render() {
        const { t, operation, data } = this.props;

        return <div className="render-card-to-list-operation">
            {this.renderOptions(operation.options)}
        </div>;
    }
};

export default withTranslation()(CardToListOperation);